import { TextInput, Button, Group, Box, Text } from "@mantine/core";
import { useForm } from "@mantine/form";
import { showNotification } from "@mantine/notifications";
import { IconCheck, IconX } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { repositorySign } from "../../_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import { NotificationExtension } from "../../extension/NotificationExtension";
import { modals } from "@mantine/modals";

export interface RepassNoCodeModel {
  userName: string;
  pass: string;
  rePass: string;
  passOld: string;
}

export function RecovyPassNodeCode() {
  const form = useForm<RepassNoCodeModel>({
    initialValues: {
      userName: "",
      pass: "",
      rePass: "",
      passOld: "",
    },
  });

  const handleSubmit = async (values: typeof form.values) => {
    try {
      form.setFieldValue("userName", localStorage.getItem("userName") ?? "");
      const response = await repositorySign.post<MessageResponse<boolean>>(
        "/api/v1/auth/repass-no-code",
        form.getValues()
      );
      if (response?.httpStatusCode === 200) {
        if (response.success) {
          NotificationExtension.Success("Đổi mật khẩu thành công!");
          modals.closeAll();
        } else NotificationExtension.Success("Đổi mật khẩu thất bại!");
      }
    } catch (error) {
      NotificationExtension.Fails("Xin vui lòng thử lại!");
    }
  };

  return (
    <Box mx="auto">
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <TextInput
          withAsterisk
          label="Mật khẩu cũ:"
          placeholder="Nhập ..."
          {...form.getInputProps("passOld")}
        />
        <TextInput
          withAsterisk
          label="Mật khẩu mới:"
          placeholder="Nhập ..."
          {...form.getInputProps("pass")}
        />
        <TextInput
          withAsterisk
          label="Nhập mật khẩu mới:"
          placeholder="Nhập ..."
          {...form.getInputProps("rePass")}
        />
        <Group mt="md" justify="space-between">
          <Button type="button" variant="outline">
            Hủy bỏ
          </Button>
          <Button type="submit">Xác nhận</Button>
        </Group>
      </form>
    </Box>
  );
}
